import { render, staticRenderFns } from "./myCustomer.vue?vue&type=template&id=5ee1dd40&"
import script from "./myCustomer.vue?vue&type=script&lang=js&"
export * from "./myCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports